import { merge } from "lodash";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Typography, Box } from "@mui/material";
import { BaseOptionChart } from "../../charts";

const staticData = {
  years: ["2024", "2023", "2022", "2021"],
  months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"],
  series: [
    { name: "2024", data: [250, 200, 130, 160, 180, 260, 200, 200, 210, 220, 230, 240] },
    { name: "2023", data: [230, 180, 120, 150, 170, 190, 200, 200, 210, 220, 230, 240] },
    { name: "2022", data: [220, 170, 110, 140, 160, 170, 180, 190, 200, 210, 220, 230] },
    { name: "2021", data: [210, 160, 100, 130, 150, 160, 170, 180, 190, 200, 210, 220] },
  ],
};

function StaticLineChart(props) {
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    if (props.year && props.year.data) {
      const series = Object.keys(props.year.data).map(year => ({
        name: year,
        data: Object.values(props.year.data[year])
      }));
      setChartSeries(series);
    } else {
      setChartSeries(staticData.series);
    }
  }, [props.year]);

  const chartOptions = merge(BaseOptionChart(), {
    colors: ["#C0D6DF", "#A5C9CA", "#92AFBA", "#5E8490", "#2E6275"],
    stroke: { width: 3, curve: "smooth" },
    markers: { size: 0 },
    xaxis: {
      categories: staticData.months,
      labels: { style: { colors: "#808080" } },
    },
    yaxis: {
      labels: { style: { colors: "#808080" } },
    },
    legend: { position: "bottom" },
  });

  return (
    <Card sx={{ boxShadow: "none", mt: 4 }}>
       <Typography variant="h4" mt={10} color="#22577A">
       Antibiotic prescriptions by year
      </Typography>
      <br />
      <Box sx={{ mx: 1 }} dir="ltr">
        <ReactApexChart
          type="line"
          series={chartSeries}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}

import { connect } from "react-redux";
const mapState = (state) => ({
  year: state.antibiotics.year,
});

const mapDispatch = ({ antibiotics: { getGeneralAB } }) => ({
  getGeneralAB: () => getGeneralAB(),
});

export default connect(mapState, mapDispatch)(StaticLineChart);

